import { gql } from '@apollo/client'

import { EVENT_FRAGMENT } from '../../../common/graphql/fragments'

import { SIMPLE_ALLERGEN_FRAGMENT } from '../fragments'

const SAVE_ALLERGENS_MUTATION = gql`
  mutation saveAllergens($data: [SimpleAllergenInput!]!) {
    saveAllergens(data: $data) {
      results {
        ...SimpleAllergenFragment
      }
      latestEvent {
        ...EventFragment
      }
    }
  }
  ${SIMPLE_ALLERGEN_FRAGMENT}
  ${EVENT_FRAGMENT}
`

export default SAVE_ALLERGENS_MUTATION
